import React from "react";
import BaseLayout from "./BaseView/BaseLayout";
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import {withStyles} from "@material-ui/core";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import Card from "../components/Card/Card";
import CardHeader from "../components/Card/CardHeader";
import CardBody from "../components/Card/CardBody";
import CardFooter from "../components2/Card/CardFooter";
import Primary from "../components/Typography/Primary";
import Divider from '@material-ui/core/Divider';
import intl from 'react-intl-universal';


class AndroidDownload extends React.Component {

	render() {
		const {classes} = this.props;
		return (
			<BaseLayout>
				<GridContainer justify="center">
					<GridItem xs={12} sm={12} md={6}>
						<Card style={{padding: "16px", backgroundColor: "#f0f0f0"}}>
							<CardHeader>
								<h2>{intl.get('download_android')}</h2>
							</CardHeader>
							<CardBody>
								<Divider/>
								<GridContainer justify="center" alignItems="center"
											   style={{marginTop: "16px", marginBottom: "16px"}}>


									<GridItem xs={12} sm={12} md={12}>
										<GridContainer justify="center" alignItems="center">
											<div style={{
												backgroundColor: "#fff",
												borderRadius: '10px',
												padding: '10px',
												boxShadow: '5px 5px 5px #999',
												width: '120px'
											}}>
												<img
													src={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/logo512.png"}
													style={{
														width: '100px',
														height: '100px',
													}}/>
											</div>
										</GridContainer>
									</GridItem>
									<Primary><h4><a
										href={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/apk/RobinAlgo.apk"}
										target={"_blank"}
									>{intl.get('download')}</a>
									</h4></Primary>

								</GridContainer>
								<Divider/>
							</CardBody>

							<CardFooter>

								<Primary><h5><a
									href={"https://play.google.com/store/apps/details?id=com.clwater.robinalgo"}
									target={"_blank"}
								>{intl.get('view_in_googleplay')}</a>
								</h5></Primary>
							</CardFooter>
						</Card>
					</GridItem>
				</GridContainer>
			</BaseLayout>
		);
	}
}

export default withStyles(styles)(AndroidDownload)